export const Env = {
  server: document.location.host.includes("local")
    ? "http://localhost:2997"
    : document.location.host.includes("photographe.ai")
    ? "https://api.photographe.ai"
    : "",
  googleoauth:
    "506096149809-vrccmssa2fp9a1lq0tk2b825lioemafo.apps.googleusercontent.com",
  posthogApiKey: "phc_8P8PTdug6gPdpNvqEnEeCx1xeqER1Kpyo6C4rsxmv6t",
  posthogApiHost: "https://eu.posthog.com",
};
